module.exports = __webpack_public_path__ + "img/icon_manejo_ajuste_facturacion.21f75be6.svg";